import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Rendezvous</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Powered by{" "}
                <a
                  target="_blank"
                  href="https://www.mhsinfotech.com.qa/"
                  rel="noreferrer"
                >
                  MHS INFOTECH
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
